import { render, staticRenderFns } from "./DialogExitProcess.vue?vue&type=template&id=a4fc43f6"
import script from "./DialogExitProcess.vue?vue&type=script&lang=ts"
export * from "./DialogExitProcess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports